module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Bold.09ad9537.ttf";